import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getManualResourceIdControl } from './shared-control-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';
import { azureMariaDBDomain } from '../linked-service/azure-maria-db-metadata';

const azureMariaDBResourceId = '/subscriptions/<subscriptionID>/resourceGroups/<resourceGroupName>/providers/Microsoft.DBforMariaDB/servers/<resourceName>';
const azureMariaDBResourceIdFormat = '\/?subscriptions\/.+\/resourceGroups\/.+\/providers\/Microsoft.DBforMariaDB\/servers\/.+';
const azureMariaDBResourceIdErrorMessage = format(stringResources.InvalidResourceId, azureMariaDBResourceId);

export const azureMariaDBPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.DBforMariaDB/servers',
    connectionSuffix: 'privateEndpoints',
    resourceIdValidator: azureMariaDBResourceIdFormat,
    groupIdMetadata: {
        mariadbServer: {
            linkedServiceType: adfModelTypeMap.azureMariaDB.linkedServiceType,
            groupId: 'mariadbServer',
            iconClass: 'svg-i-100x100-AzureMariaDB',
            displayName: stringResources.AzureMariaDB_DisplayText,
            controls: {
                creationControls: [{
                    type: 'radio-switch',
                    nested: 1,
                    label: stringResources.AccountSelectionMethodLabel,
                    description: stringResources.AzureSql_SelectMethodDescription,
                    options: azureResourceSelectMethodOptions,
                    isLabelVertical: true,
                    defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
                    cases: [
                        {
                            caseValue: 'azure',
                            children: [
                                {
                                    type: 'azure-server-database-select',
                                    bind: {
                                        resourceID: 'privateLinkResourceId'
                                    },
                                    resourceTypes: ['Microsoft.DBforMariaDB/servers'],
                                    serverDomain: azureMariaDBDomain,
                                    isServerSelectOnly: true,
                                    validators: {
                                        resourceID: [
                                            { type: 'required', errorMessage: '' }
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            caseValue: 'manual',
                            children: [
                                getManualResourceIdControl(
                                    format(stringResources.PrivateEndpointResourceIdPlaceholder, azureMariaDBResourceId),
                                    azureMariaDBResourceIdFormat,
                                    azureMariaDBResourceIdErrorMessage)
                            ]
                        }
                    ]
                }],
                readonlyControls: getReadonlyControl(azureMariaDBResourceIdFormat, azureMariaDBResourceIdErrorMessage)
            }
        }
    }
};
